import styled from 'styled-components';
import { Table } from './Table';

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

export const Title = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Actions = styled.div`
  display: flex;
  gap: 16px;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const Footer = styled.footer`
  position: relative;
  text-align: center;
`;

export default styled.div`
  background-color: white;
  border-radius: 6px;
  box-shadow: var(--level-1);
  width: 100%;
  padding: 8px 0;

  > ${Header}, ${Body}, ${Footer} {
    padding: 8px 24px;
  }

  > ${Table} {
    border-top: 1px solid var(--tint-black);
  }
`;
